import ColescbaApp from '@colescba/app-vue'
import ColescbaAuthVue from '@colescba/auth-vue'
import ColescbaUI from '@colescba/ui'

// caracteristicas habilitadas
const features = {
  delegacion: true,
  notificaciones: true,
  padAplicaciones: true,
  acreditadorNuevo: true,
}

// plugins a instalar
const plugins = {
  auth: ColescbaAuthVue,
  ui: ColescbaUI,
}

import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
Settings.defaultLocale = 'es'

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.use(ColescbaApp, { env: process.env, plugins, features })
    Vue.component('datetime', Datetime)
  },
}
